"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
var SmartyStreetsService = /*#__PURE__*/(0, _createClass2.default)(function SmartyStreetsService(config) {
  var _this = this;
  (0, _classCallCheck2.default)(this, SmartyStreetsService);
  (0, _defineProperty2.default)(this, "getSuggestions", function (input) {
    var params = {
      'auth-id': _this.authId,
      max_results: _this.suggestions,
      search: input.value
    };
    return (0, _lcHttp.default)({
      url: _this.suggestionURL,
      params: params,
      useCsrf: false
    });
  });
  this.authId = config.authId;
  this.suggestions = config.suggestions;
  this.suggestionURL = config.suggestionURL;
});
var _default = SmartyStreetsService;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-address-service/dist/pf-address-service.scss');